import { defineMessages } from "react-intl";

export const SelectModalSaveButtonTooltipText = defineMessages({
  saveButtonLabel: {
    defaultMessage: "Save and close",
    id: "f+c7y3",
  },
});
